<template>
  <form :action="action" :method="method" @submit="onSubmit" ref="form">
    <input v-if="token" type="hidden" name="_token" :value="token">
    <input type="hidden" name="form_id" :value="formId" v-if="formId">
    <fieldset class="uk-fieldset">
      <legend class="uk-legend">
        <slot name="name"></slot>
      </legend>
      <slot name="description"></slot>
      <div class="uk-alert uk-alert-danger" v-if="hasErrors">
        <span>{{ $t('rubinred.forms.forms.message.submission.error') }}</span>
      </div>
      <div class="uk-alert uk-alert-success" v-if="hasAlerts">
        <p v-for="message in alerts">{{ message }}</p>
      </div>
      <slot name="fields"></slot>
      <slot name="privacies"></slot>
      <slot name="submit"></slot>
      <slot name="footer"></slot>
    </fieldset>
  </form>
</template>
<script>
  import Form from "rubinred/forms/js/mixins/Form";

  export default {
    mixins: [Form],
  }
</script>



// WEBPACK FOOTER //
// public/themes/frontend/uikit3/extensions/rubinred/forms/assets/js/components/RubinredForm.vue